import { Howl, Howler } from "howler";
import { path } from "../settings";

const audioBundle = {
  enkC: "Victory-Enk-C.mp3",
  enkD: "Victory-Enk-D.mp3",
  mini: "Victory-Mini-win-Final.mp3",
  mega: "Victory-Mega-win-Final.mp3",
  ultra: "Victory-Ultra-win-Final.mp3",
};

export const audioBundle2 = {
  airPump: "AirPump.mp3",
  ballonExp1: "ballonExplosion1.mp3",
  ballonExp2: "ballonExplosion2.mp3",
  ballonExp3: "ballonExplosion3.mp3",
  ballonInf1: "ballonInflate1.mp3",
  ballonInf2: "ballonInflate2.mp3",
  ballonInf3: "ballonInflate3.mp3",
  ballonInf4: "ballonInflate4.mp3",
  ballonInf5: "ballonInflate5.mp3",
  ballonInf6: "ballonInflate6.mp3",
  ballonInf7: "ballonInflate7.mp3",
  bannerFlag: "bannerFlag.mp3",
  mainBg: "mainBg.mp3",
  multiplier1: "multiplier1.mp3",
  multiplier2: "multiplier2.mp3",
  multiplier3: "multiplier3.mp3",
  ripReveal1:"ripReveal1.mp3",
  popupOpen: "popupOpen.mp3",
  popupClose: "popupClose.mp3",
  popupTabChange: "popupTabChange.mp3",
  plus: "plus.mp3",
  minus: "minus.mp3",
  disable: "disable.mp3",
  on:"on.mp3",
  off:"off.mp3",
  play:"play.mp3",
  big: 'Bigwin.mp3',
  megaWin: 'Bigwin-Megawin.mp3',
  ultraWin: 'Bigwin-Megawin-Ultrawin.mp3',
  rip1: 'Rip-Reveal 1.mp3',
  rip2: 'Rip-Reveal 2.mp3',
  rip3: 'Rip-Reveal 3.mp3',
  rip4: 'Rip-Reveal 4.mp3'
}


function createSoundsArray(audioConstants) {
  return Object.values(audioConstants);
}

const audios = {};

export async function loadSounds() {
  
  try {
    const gameSounds = await loadSoundBundle(audioBundle2, path.sounds);
    Object.assign(audios, gameSounds);

    const victorySounds = await loadSoundBundle(audioBundle, path.victoryAudioPath);
    Object.assign(audios, victorySounds);

    return audios;
  } catch (error) {
    // console.error("Error loading sounds:", error);
    throw error;
  }
}

async function loadSoundBundle(bundle, path) {
  const sounds = createSoundsArray(bundle);
  const audio = {};

  const promises = sounds.map((sound) => {
    return new Promise((resolve) => {
      const howl = new Howl({
        src: [path + sound],
        volume: sound === audioBundle2['mainBg'] ? 0.2 : 1,
        loop: sound === audioBundle2['mainBg'],
        onload: () => {
          audio[sound] = howl
          resolve()
        },
        onloaderror: (id, error) => {
          // console.error(`Failed to load sound: ${sound}, Error:`, error)
          resolve()
        },
      });
    });
  });

  await Promise.all(promises);
  return audio;
}


export function playEnkCAudio(shouldPlay) {
  if(sfxSound.value && shouldPlay) playSound(audioBundle.enkC)
  else stopSound(audioBundle.enkC)
}

export function playEnkDAudio(shouldPlay) {
  if(sfxSound.value && shouldPlay) playSound(audioBundle.enkD)
  else stopSound(audioBundle.enkD)
}

export function playMiniAudio(shouldPlay) {
  if(sfxSound.value && shouldPlay) playSound(audioBundle.mini)
  else stopSound(audioBundle.mini)
}

export function playMegaAudio(shouldPlay) {
  if(sfxSound.value && shouldPlay) playSound(audioBundle.mega)
  else stopSound(audioBundle.mega)
}

export function playBigAudio(shouldPlay) {
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.big)
  else stopSound(audioBundle2.big)
}

export function playUltraAudio(shouldPlay) {
  if(sfxSound.value && shouldPlay) playSound(audioBundle.ultra)
  else stopSound(audioBundle.ultra)
}

//Normal Sounds
export function playAirPump(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.airPump)
  else stopSound(audioBundle2.airPump)
}

export function playBallonExp(soundExp, shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2[soundExp])
  else stopSound(audioBundle2[soundExp])
}

export function playBallonExp1(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonExp1)
  else stopSound(audioBundle2.ballonExp1)
}

export function playBallonExp2(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonExp2)
  else stopSound(audioBundle2.ballonExp2)
}

export function playBallonExp3(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonExp3)
  else stopSound(audioBundle2.ballonExp3)
}

export function playballonInf1(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf1)
  else stopSound(audioBundle2.ballonInf1)
}

export function playballonInf2(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf2)
  else stopSound(audioBundle2.ballonInf2)
}

export function playballonInf3(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf3)
  else stopSound(audioBundle2.ballonInf3)
}

export function playballonInf4(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf4)
  else stopSound(audioBundle2.ballonInf4)
}

export function playballonInf5(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf5)
  else stopSound(audioBundle2.ballonInf5)
}


export function playballonInf6(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf6)
  else stopSound(audioBundle2.ballonInf6)
}

export function playballonInf7(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ballonInf7)
  else stopSound(audioBundle2.ballonInf7)
}

export function playMultiplier1(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.multiplier1)
  else stopSound(audioBundle2.multiplier1)
}

export function playMultiplier2(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.multiplier2)
  else stopSound(audioBundle2.multiplier2)
}

export function playMultiplier3(shouldPlay){

  if(sfxSound.value && shouldPlay) playSound(audioBundle2.multiplier3)
  else stopSound(audioBundle2.multiplier3)
}

export function playMainBg(shouldPlay){

  if(mainBgSound.value && shouldPlay) playSound(audioBundle2.mainBg)
  else stopSound(audioBundle2.mainBg)
}

export function playRipReveal1(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ripReveal1)
  else stopSound(audioBundle2.ripReveal1)
}

export function playPopUpOpen(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.popupOpen)
    else stopSound(audioBundle2.popupOpen)
}

export function playPopUpClose(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.popupClose)
    else stopSound(audioBundle2.popupClose)
}

export function playPopTabChange(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.popupTabChange)
    else stopSound(audioBundle2.popupTabChange)
}

export function playPlus(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.plus)
    else stopSound(audioBundle2.plus)
}

export function playMinus(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.minus)
    else stopSound(audioBundle2.minus)
}

export function playDisable(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.disable)
    else stopSound(audioBundle2.disable)
}

export function playOn(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.on)
    else stopSound(audioBundle2.on)
}

export function playOff(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.off)
    else stopSound(audioBundle2.off)
}

export function playPlay(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.play)
    else stopSound(audioBundle2.play)
}

export function playMegaWin(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.megaWin)
    else stopSound(audioBundle2.megaWin)
}

export function playUltraWin(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.ultraWin)
    else stopSound(audioBundle2.ultraWin)
}

export function playrip1(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.rip1)
    else stopSound(audioBundle2.rip1)
}

export function playrip2(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.rip2)
    else stopSound(audioBundle2.rip2)
}

export function playrip3(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.rip3)
    else stopSound(audioBundle2.rip3)
}

export function playrip4(shouldPlay){
  if(sfxSound.value && shouldPlay) playSound(audioBundle2.rip4)
    else stopSound(audioBundle2.rip4)
}

export function globalVolumes(value) {  
  Howler.volume(value);
}

const playSound = (sound) => {
  const howl = audios[sound];
  if (howl) {
    howl.play()
  } else {
    // console.error(`Error playing sound: ${sound}. Sound not loaded.`);
  }
}

const stopSound = (sound) => {
  const howl = audios[sound];
  if (howl) {
    howl.stop()
  } else {
    // console.error(`Error stopping sound: ${sound}. Sound not loaded.`);
  }
}

export function stopAllExceptMainBgSound() {
  Object.keys(audios).forEach((soundName) => {
    if (soundName !== audioBundle2['mainBg']) {
      stopSound(soundName)
    }
  })
}


export const sfxSound = {
  _value: true,

  get value() {
    return this._value;
  },


  set value(v) {
    this._value = v;
  }
}

export const mainBgSound = {
  _value: true,

  get value() {
    return this._value;
  },


  set value(v) {
    this._value = v;
  }
}

